import { useEffect, useState, useRef } from "react";
import api from "@/lib/api";
import { Terminal } from "lucide-react";

const COLORS = {
  success: "text-emerald-400",
  error: "text-red-400",
  warning: "text-amber-400",
  info: "text-zinc-400",
};

export default function ActivityLog({ refreshKey }) {
  const [logs, setLogs] = useState([]);
  const bodyRef = useRef(null);

  const load = async () => {
    try {
      const { data } = await api.get("/admin/logs", { params: { limit: 100 } });
      setLogs((data.logs || []).slice().reverse());
    } catch {
      /* ignore */
    }
  };

  useEffect(() => {
    load();
    const t = setInterval(load, 5000);
    return () => clearInterval(t);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [refreshKey]);

  useEffect(() => {
    if (bodyRef.current) bodyRef.current.scrollTop = bodyRef.current.scrollHeight;
  }, [logs]);

  const ts = (s) => {
    try {
      return new Date(s).toLocaleTimeString([], { hour12: false });
    } catch {
      return "";
    }
  };

  return (
    <div className="flex h-full flex-col rounded-sm border border-zinc-800 bg-zinc-900 p-6" data-testid="activity-log">
      <div className="mb-4 flex items-center gap-2">
        <Terminal className="h-5 w-5 text-emerald-400" />
        <h2 className="font-heading text-lg font-semibold tracking-tight text-zinc-100">Activity Log</h2>
      </div>
      <div
        ref={bodyRef}
        className="flex-1 overflow-auto rounded-sm border border-zinc-800 bg-zinc-950 p-3 shadow-inner"
      >
        {logs.length === 0 ? (
          <p className="font-mono text-xs text-zinc-600">// no activity yet — waiting for events…</p>
        ) : (
          <ul className="space-y-1.5">
            {logs.map((l, i) => (
              <li key={i} className="flex gap-2 font-mono text-xs leading-relaxed">
                <span className="flex-none text-zinc-600">{ts(l.timestamp)}</span>
                <span className={`flex-none uppercase ${COLORS[l.level] || "text-zinc-400"}`}>
                  [{l.level}]
                </span>
                <span className="text-zinc-400">{l.message}</span>
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
}
